import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { Tabs, TabsStrategy } from '../../components/Tabs';
import {
  PATH_MATERIAL_ADMIN,
  PATH_MATERIAL_ADMIN_EDIT,
  PATH_MATERIAL_COSTS,
  PATH_MATERIAL_COSTS_EDIT,
  PATH_MATERIAL_DEFAULT,
  PATH_MATERIAL_GENERAL,
  PATH_MATERIAL_GENERAL_EDIT,
  PATH_MATERIAL_VERSIONS,
} from '../../app/constants/paths.constant';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';

import { Admin } from './Admin';
import { Costs } from './Costs';
import { GeneralInfo } from './GeneralInfo';
import { Versions } from './Versions';

export const MaterialPage_Tabs_Material_Fragment = graphql(`
  fragment MaterialPage_Tabs_Material_Fragment on Material {
    _id
    ...MaterialPage_GeneralInfo_Material_Fragment
    ...MaterialPage_Costs_Material_Fragment
    ...MaterialPage_Admin_Material_Fragment
  }
`);

interface Props {
  readonly material: FragmentType<typeof MaterialPage_Tabs_Material_Fragment>;
}

export const MaterialTabs = ({ material: pMaterial }: Readonly<Props>) => {
  const material = getFragmentData(
    MaterialPage_Tabs_Material_Fragment,
    pMaterial,
  );

  const { paths, getActiveTab } = useBuildPaths(
    {
      admin: PATH_MATERIAL_ADMIN,
      adminEdit: PATH_MATERIAL_ADMIN_EDIT,
      costs: PATH_MATERIAL_COSTS,
      costsEdit: PATH_MATERIAL_COSTS_EDIT,
      default: PATH_MATERIAL_DEFAULT,
      generalInfo: PATH_MATERIAL_GENERAL,
      generalInfoEdit: PATH_MATERIAL_GENERAL_EDIT,
      versions: PATH_MATERIAL_VERSIONS,
    },
    {
      id: material._id,
    },
    {
      admin: 'admin',
      adminEdit: 'admin',
      costs: 'costs',
      costsEdit: 'costs',
      default: 'generalInfo',
      generalInfo: 'generalInfo',
      generalInfoEdit: 'generalInfo',
      versions: 'versions',
    },
  );

  return (
    <Tabs
      activeTab={getActiveTab()}
      id="material-tabs"
      strategy={TabsStrategy.Controlled}
      tabs={[
        {
          key: 'generalInfo',
          label: 'Informations Générales',
          panel: <GeneralInfo material={material} />,
          to: paths.generalInfo,
          value: 'generalInfo',
        },
        {
          key: 'costs',
          label: 'Coûts Liés',
          panel: <Costs material={material} />,
          to: paths.costs,
          value: 'costs',
        },
        {
          key: 'versions',
          label: 'Versions',
          panel: <Versions originalId={material._id} />,
          to: paths.versions,
          value: 'versions',
        },
        {
          key: 'admin',
          label: 'Administration',
          panel: <Admin material={material} />,
          to: paths.admin,
          value: 'admin',
        },
      ]}
      title="Onglets de l'écran de Fiche d'un Matériel"
    />
  );
};
